<template>
    <main>
		<HeaderTab 
            :title="$t('global.notes')"
            :icon="['fal', 'sticky-note']"
        />

		<div id="content">
			<div class="container-fluid">
                <div class="row">
					<div class="col-12">
						<NotesList />
					</div>
				</div>
			</div>
		</div>
	</main>
</template>


<script type="text/javascript">
	export default {
		name: "noteListe",
		components: {
            HeaderTab: () => import('@/components/HeaderTab'),
			NotesList: () => import('@/components/Notes/List')
		}
	}
</script>
